//import React from 'react';
import { post, BASE_URL } from '../../src/client'; // 위에서 만든 apiClient.js 파일 가져오기

// BASE_URL은 프로젝트 환경에 따라 설정
// const BASE_URL = 'http://52.79.160.172:8001'; 

export const loginPost = async (username, password) => {
    //console.log("Login!")
  const payloadObj = {
    username: username,
    password: password,
  };

  try {
    const responseBody = await post(BASE_URL, '/v1/users/signin', payloadObj);


    localStorage.setItem('authToken', responseBody.access_token)

            const userString = JSON.stringify(responseBody.user); 
    localStorage.setItem('user', userString)
    const savedToken = localStorage.getItem('user');
    const storedUserObject = JSON.parse(savedToken);

        


    // 로그인 성공 후 로직 추가:
    // 예: 토큰 저장, 사용자 정보 상태 업데이트, 페이지 이동 등
    // localStorage.setItem('authToken', responseBody.accessToken);

  } catch (error) {
    console.error('Login failed:', error.message);
    // 에러에 따른 사용자 알림 표시 등
  }
};

export const socialLoginPost = async (type, token) => {

  console.log(type)
    console.log(token)

    const payloadObj = {
    account_type: type,
    access_token : token

  };

  try {
    const responseBody = await post(BASE_URL, '/v1/users/reactsignin', payloadObj);
          if(responseBody == 'INVALID_USERNAME'){
          return responseBody
    }
    localStorage.setItem('authToken', responseBody.access_token)

            const userString = JSON.stringify(responseBody.user); 
    localStorage.setItem('user', userString)
    const savedToken = localStorage.getItem('user');
    const storedUserObject = JSON.parse(savedToken);
    return responseBody
        


    // 로그인 성공 후 로직 추가:
    // 예: 토큰 저장, 사용자 정보 상태 업데이트, 페이지 이동 등
    // localStorage.setItem('authToken', responseBody.accessToken);

  } catch (error) {
    console.log('Login failed:', error.message);
    // 에러에 따른 사용자 알림 표시 등
  }

}


